import React, { Component } from 'react';
import { IntlProvider } from 'react-intl';

import messages_en from '../../translations/en.js';
import messages_es from '../../translations/es.js';
import { RegistrationService } from '../registration.service';

const ENGLISH = 'en-US';
const SPANISH = 'es-US';

const messages = {
  [ENGLISH]: messages_en,
  [SPANISH]: messages_es,
};

const IntlContext = React.createContext({
  locale: ENGLISH,
  messages: messages[ENGLISH],
  toggleLocale: () => {},
});

const IntlConsumer = IntlContext.Consumer;

export default class IntlProviderWrapper extends Component {
  constructor(props) {
    super(props);

    this.registrationService = new RegistrationService();

    this.state = {
      locale:
        this.registrationService.getUrlSearchToObj().locale === 'es'
          ? SPANISH
          : ENGLISH,
    };

    this.toggleLocale = locale =>
      this.setState(prevState => ({
        locale: prevState.locale === ENGLISH ? SPANISH : ENGLISH,
      }));
  }

  render() {
    const { children } = this.props;
    const { locale } = this.state;

    return (
      <IntlContext.Provider value={{ locale, toggleLocale: this.toggleLocale }}>
        <IntlProvider
          key={locale}
          locale={locale}
          messages={messages[locale]}
          defaultLocale="en"
        >
          {children}
        </IntlProvider>
      </IntlContext.Provider>
    );
  }
}

export { IntlContext, IntlConsumer };



// WEBPACK FOOTER //
// ./registration-react/components/IntlProviderWrapper.js